import React from 'react';

// Styles //
import "./radioSquare.scss";
import { validPathname } from '../../../utils/helpers';

interface RadioSquareProps {
    setInputValue: (nombreId, value, type) => void;
    nombreId: string;
    type: string;
    options?: any[];
    value: string;
    modality?: string;
}

const RadioSquare = (props: RadioSquareProps) => {
    const {nombreId, type, options, setInputValue, value, modality } = props;

    return (
        <div className="a-radio-square">
            {(options || []).map((option, index) => {
               if(option === "No me interesa "){
                  return (
                     <>
                        <div className="a-radio-square__label">
                           <label htmlFor={nombreId + "_" + option} key={index} className="a-radio-square__label__text">
                              <input
                                 type="radio"
                                 id={nombreId + "_" + option}
                                 name={nombreId}
                                 value={option ?? ""}
                                 checked={value === option}
                                 onChange={(e) =>
                                    setInputValue(
                                       nombreId,
                                       e.target.value,
                                       type
                                    )
                              }/>
                              <span>{option}</span>
                           </label>
                        </div>
                     </>
                  );
               }else{
                  const d = option.split("/");
                  return (
                     <>
                        <div className="a-radio-square__label">
                           <p className='a-radio-square__label__modality'>{validPathname("cursos-regiones") ? `Habilidades para la vida` : `Modalidad ${modality}`}</p>
                           <label htmlFor={nombreId + "_" + option} key={index} className='a-radio-square__label__text'>
                              <input
                                 type="radio"
                                 id={nombreId + "_" + option}
                                 name={nombreId}
                                 value={option ?? ""}
                                 checked={value === option}
                                 onChange={(e) =>
                                    setInputValue(
                                       nombreId,
                                       e.target.value,
                                       type
                                    )
                              }/>
                              <span>{d[0]}</span>
                           </label>
                           <p className='a-radio-square__label__duration'>Duración: {d[1]}</p>
                        </div>
                     </>
                  );
               }
            })}
        </div>
    )
}

export default RadioSquare
